import type { Transaction } from 'prosemirror-state';
import { Plugin } from 'prosemirror-state';
import { findParentNode } from 'prosemirror-utils';
import Extension from '../lib/Extension';

// we update the URL hash when users focus/unfocus a node with link
export default class Hash extends Extension {
	get name() {
		return 'hash';
	}

	get plugins() {
		return [
			new Plugin({
				filterTransaction: (tr: Transaction) => {
					// this is a hack!
					// we run the logic below inside the filterTransaction callback because view.update won't give us the selectionSet information
					if (!tr.selectionSet) {
						return true;
					}

					// See if focused on heading node
					const headingNode = findParentNode(
						(node) => node.type.name === 'heading'
					)(tr.selection);

					if (headingNode?.node?.attrs?.id) {
						const anchorId = headingNode.node.attrs.id;
						window.history.replaceState(null, '', `#${anchorId}`);
						return true;
					}

					// See if selection has a comment mark
					const commentMark = tr.selection.$anchor
						.marks()
						.find((mark) => mark.type.name === 'comment');
					if (commentMark?.attrs.commentID) {
						window.history.replaceState(
							null,
							'',
							`#${commentMark.attrs.commentID}`
						);
						return true;
					}

					// Clear the hash if user is not focusing on a heading or comment
					window.history.replaceState(
						null,
						'',
						window.location.pathname + window.location.search
					);
					return true;
				},
			}),
		];
	}
}
